import React, { useEffect, useRef } from 'react';

import email from 'assets/images/svg/mail.svg';
import phone from 'assets/images/svg/phone.svg';
import telegram from 'assets/images/svg/telegram.svg';

import { Deal } from '../../../../api-client/models/user/Deal';
import { Image } from '../../../common';
import styles from './ProfileManager.module.scss';

interface Props {
  deal: Deal;
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

const worksFrom = '9:00';
const worksUntil = '19:00';

export const ProfileManager: React.FC<Props> = ({ deal, visible, setVisible }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
        setVisible(false);
      }
    };

    if (visible) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [visible]);

  if (!deal) return null;

  let tgUsername;
  if (deal.assignedManagerTelegram) {
    const filterSlash = deal.assignedManagerTelegram.split('/');
    const filterMailSign = filterSlash[filterSlash.length - 1].split('@');
    tgUsername = filterMailSign[filterMailSign.length - 1];
  }

  return (
    <div className={styles.wrapper} ref={wrapperRef}>
      <div className={styles.tooltip}>
        <div className={styles.headerArea}>
          <div className={styles.nameArea}>
            <div className={styles.name}>{deal.assignedManagerName || '—'}</div>
            <div className={styles.title}>Ваш инвестиционный менеджер</div>
          </div>
        </div>

        <div className={styles.contactsArea}>
          <div className={styles.contactItem}>
            <Image src={phone} className={styles.contactIcon} alt="Телефон" />
            <span className={styles.contactText}>{deal.assignedManagerPhone || '—'}</span>
          </div>
          <div className={styles.contactItem}>
            <Image src={telegram} className={styles.contactIcon} alt="Telegram" />
            {deal.assignedManagerTelegram && (
              <a href={'https://t.me/' + tgUsername}>{tgUsername}</a>
            )}
            {!deal.assignedManagerTelegram && '—'}
          </div>
          <div className={styles.contactItem}>
            <Image src={email} className={styles.contactIcon} alt="Email" />
            <span className={styles.contactText}>{deal.assignedManagerEmail || '—'}</span>
          </div>
        </div>

        <div className={styles.hoursArea}>
          <div className={styles.hoursLabel}>часы работы</div>
          <div className={styles.hoursTime}>
            с {worksFrom} до {worksUntil}
          </div>
        </div>
      </div>
    </div>
  );
};
